import { render, staticRenderFns } from "./SalariePrintReport.vue?vue&type=template&id=2a032056&scoped=true"
import script from "./SalariePrintReport.vue?vue&type=script&lang=js"
export * from "./SalariePrintReport.vue?vue&type=script&lang=js"
import style0 from "./SalariePrintReport.vue?vue&type=style&index=0&id=2a032056&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a032056",
  null
  
)

export default component.exports